import { IOfferableRepository } from '@modules/is-offerable/domain'
import { solarSalesAxios } from '@infrastructure/apiService'

export const isOfferableService: IOfferableRepository = {
  isOfferable: async (cups) => {
    const { data } = await solarSalesAxios.get(`cups/${cups}/is-offerable`)
    return Boolean(data.isOfferable)
  },
}
